import { AppBar, Grid, Tab, Tabs } from "@mui/material";
import { TabPanel } from "components/TabPanel";
import TabToolbarPlaceholder from "components/TabToolbarPlaceholder";
import technicianSettings from "helpers/technicianSettings";
import { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useAppDispatch } from "store";
import { setAppBar } from "store/slices/menu.store";
import { getTechStock, resetStockPage } from "store/slices/stock.store";
import { StockOrderTab } from "./tabs/StockOrderTab";
import { StockSearchTab } from "./tabs/StockSearchTab";
import { StockSyncTab } from "./tabs/StockSyncTab";

export const StockPage: FC = () => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const [tabValue, setTabValue] = useState("search");
  const [fab, setFab] = useState<JSX.Element | undefined>(undefined);
  const allowChangeStock =
    technicianSettings.allowMoveStock ||
    technicianSettings.allowOrderStock ||
    technicianSettings.allowUpdateStock;

  useEffect(() => {
    dispatch(
      setAppBar({
        title: intl.formatMessage({ id: "menu.stockEnquiry" }),
      }),
    );
  }, [dispatch, intl]);

  useEffect(() => {
    dispatch(getTechStock());
  }, [dispatch]);

  useEffect(() => {
    dispatch(resetStockPage());
  }, [dispatch]);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          mt: 7,
          backgroundColor: `primary.main`,
        }}
      >
        <Tabs
          scrollButtons
          value={tabValue}
          onChange={(_, newValue: string) => {
            setTabValue(newValue);
          }}
          variant="scrollable"
          textColor="inherit"
        >
          <Tab label={intl.formatMessage({ id: "stock.search" })} value="search" />
          {technicianSettings.allowOrderStock && (
            <Tab label={intl.formatMessage({ id: "stock.order" })} value="order" />
          )}
          {technicianSettings.allowUpdateStock && (
            <Tab label={intl.formatMessage({ id: "stock.update" })} value="update" />
          )}
          {technicianSettings.allowMoveStock && (
            <Tab label={intl.formatMessage({ id: "stock.move" })} value="move" />
          )}
        </Tabs>
      </AppBar>
      <TabToolbarPlaceholder />

      <TabPanel index="search" value={tabValue}>
        <StockSearchTab setFab={() => setFab(undefined)} />
      </TabPanel>
      {technicianSettings.allowOrderStock && (
        <TabPanel index="order" value={tabValue}>
          <StockOrderTab setFab={setFab} />
        </TabPanel>
      )}
      {technicianSettings.allowUpdateStock && (
        <TabPanel index="update" value={tabValue}>
          <StockSyncTab setFab={setFab} moveStock={false} />
        </TabPanel>
      )}
      {technicianSettings.allowMoveStock && (
        <TabPanel index="move" value={tabValue}>
          <StockSyncTab setFab={setFab} moveStock />
        </TabPanel>
      )}

      {allowChangeStock && (
        <Grid
          container
          direction="column"
          width="inherit"
          sx={{
            position: "fixed",
            bottom: 0,
            right: 0,
          }}
        >
          {fab}
        </Grid>
      )}
    </>
  );
};
